import React from 'react';
import { useTranslation } from 'react-i18next';

const BOOKING_STATES = {
  open: { key: 'manage.statusUpcoming', fallback: 'Upcoming', color: 'bg-blue-100 text-blue-800' },
  active: { key: 'manage.statusActive', fallback: 'Active', color: 'bg-green-100 text-green-800' },
  returned: { key: 'manage.statusCompleted', fallback: 'Completed', color: 'bg-gray-100 text-gray-800' },
  cancelled: { key: 'manage.statusCancelled', fallback: 'Cancelled', color: 'bg-red-100 text-red-800' }
};

const PAYMENT_STATES = {
  open: { key: 'manage.paymentUnpaid', fallback: 'Unpaid', color: 'bg-yellow-100 text-yellow-800' },
  open_pay_later: { key: 'manage.paymentPayLater', fallback: 'Pay Later', color: 'bg-orange-100 text-orange-800' },
  paid: { key: 'manage.paymentPaid', fallback: 'Paid', color: 'bg-green-100 text-green-800' },
  refunded: { key: 'manage.paymentRefunded', fallback: 'Refunded', color: 'bg-gray-100 text-gray-800' },
  partially_refunded: { key: 'manage.paymentPartialRefund', fallback: 'Partial Refund', color: 'bg-yellow-100 text-yellow-800' }
};

export default function BookingStatusBadge({ bookingState, paymentState }) {
  const { t } = useTranslation();
  const bs = BOOKING_STATES[bookingState];
  const ps = PAYMENT_STATES[paymentState] || null;

  const bsLabel = bs ? t(bs.key, bs.fallback) : bookingState;
  const bsColor = bs ? bs.color : 'bg-gray-100 text-gray-800';

  return (
    <div className="flex flex-wrap gap-2">
      <span className={`px-3 py-1 rounded-full text-xs font-semibold ${bsColor}`}>
        {bsLabel}
      </span>
      {ps && paymentState !== 'paid' && (
        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${ps.color}`}>
          {t(ps.key, ps.fallback)}
        </span>
      )}
    </div>
  );
}
